import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { zPipelineTypeFilter } from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

export const newUserPipelineSearchSchema = z.object({
  from: z.string().optional().catch(undefined),
  function_expertise: zFiltersArray(),
  industry_expertise: zFiltersArray(),
  point_of_contact_person_id: z.string().optional().catch(undefined),
  type: zPipelineTypeFilter.optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_private/_route/users/$userId/pipelines/new',
)({
  validateSearch: newUserPipelineSearchSchema,
});
